import { useEffect, useState } from 'react';
import axios from 'axios';
import { Shield, Stethoscope, MapPin, GraduationCap, Headphones } from 'lucide-react';
import { API } from '@/App';

const ACCOUNTS = [
  { key: 'admin', label: 'Administrateur', icon: Shield, cls: 'bg-[#1e3a5f]/5 hover:bg-[#1e3a5f]/10 text-[#1e3a5f]', testId: 'quick-login-admin' },
  { key: 'ophtalmo', label: 'Ophtalmologiste', icon: Stethoscope, cls: 'bg-[#35AFE4]/5 hover:bg-[#35AFE4]/10 text-[#35AFE4]', testId: 'quick-login-ophtalmo' },
  { key: 'regional', label: 'Responsable de région', icon: MapPin, cls: 'bg-amber-50 hover:bg-amber-100 text-amber-700', testId: 'quick-login-regional' },
  { key: 'interne', label: 'Interne', icon: GraduationCap, cls: 'bg-emerald-50 hover:bg-emerald-100 text-emerald-700', testId: 'quick-login-interne' },
  { key: 'support', label: 'Support Technique', icon: Headphones, cls: 'bg-orange-50 hover:bg-orange-100 text-orange-700', testId: 'quick-login-support' },
];

// Demo quick-login: shown only when the server says this is the preview site (never in production).
export const DemoQuickLogin = ({ onLogin, loading }) => {
  const [enabled, setEnabled] = useState(false);
  useEffect(() => { axios.get(`${API}/auth/demo-config`).then(r => setEnabled(!!r.data.enabled)).catch(() => {}); }, []);
  if (!enabled) return null;
  return (
    <div className="mt-6 pt-5 border-t border-gray-100">
      <p className="text-[10px] text-gray-400 uppercase tracking-wider font-bold text-center mb-3">Connexion rapide</p>
      <div className="mb-3 p-3 rounded-xl bg-gradient-to-br from-[#35AFE4]/8 to-[#1e3a5f]/5 border border-[#35AFE4]/20" data-testid="demo-mode-banner">
        <p className="text-[12px] font-bold text-[#1e3a5f]">Mode démo (préversion uniquement)</p>
        <p className="text-[11px] text-gray-600 leading-snug mt-0.5">
          Explorez chaque rôle. Les actions faites avec ces comptes sont supprimées <strong>12 h après</strong>. Ces boutons n'existent pas sur le site en production.
        </p>
      </div>
      <div className="space-y-2">
        {ACCOUNTS.map(({ key, label, icon: Icon, cls, testId }) => (
          <button key={key} type="button" onClick={() => onLogin(key)} disabled={loading}
            className={`w-full flex items-center justify-center gap-2 px-4 py-2.5 rounded-full text-sm font-semibold transition-colors disabled:opacity-50 ${cls}`}
            data-testid={testId}>
            <Icon size={14} /> {label}
          </button>
        ))}
      </div>
    </div>
  );
};
